import { GridPageChangeEvent, GridPagerSettings } from '@progress/kendo-react-grid';
import { Page } from '@progress/kendo-react-grid/dist/npm/paging/Page';
import { useMemo, useState } from 'react';

export const usePageableGrid = (
    pageSizes?: boolean | number[],
    take?: number
): [
    {
        onPageChange: (e: GridPageChangeEvent) => void;
        skip: number;
        take: number;
        pageable: GridPagerSettings;
    },
    React.Dispatch<React.SetStateAction<Page>>
] => {
    const pageable: boolean | GridPagerSettings = { pageSizes: pageSizes };
    const [page, setPage] = useState<Page>({
        skip: 0,
        take: take ? take : typeof pageSizes === 'boolean' || (pageSizes?.length ?? 0) === 0 ? 10 : pageSizes[0]
    });
    const onPageChange = (e: GridPageChangeEvent) => {
        setPage(e.page);
    };

    return useMemo(() => [{ pageable, ...page, onPageChange }, setPage], [page]);
};
